import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { TreeState } from './types'

const INITIAL_STATE: TreeState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendTreeError: '',
  sendTreeLoading: false,
  total_results: 0
}

const reducer = createReducer<TreeState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getTree, state => ({
    ...state,
    error: '',
    list: [],
    loading: true
  }))
  .handleAction(Actions.getTreeFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getTreeSuccess, (state, { payload }) => ({
    ...state,
    list: payload.trees,
    loading: false
  }))

export default reducer
